// Recovered compiled webpack factory 83571. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      DYNAMIC_STALETIME_MS: function () {
        return d;
      },
      STATIC_STALETIME_MS: function () {
        return p;
      },
      createSeededPrefetchCacheEntry: function () {
        return u;
      },
      getOrCreatePrefetchCacheEntry: function () {
        return l;
      },
      prunePrefetchCache: function () {
        return f;
      },
    }));
  let n = r(32753),
    a = r(86871),
    o = r(43933);
  function i(e, t, r) {
    let n = e.pathname;
    return (t && (n += e.search), r) ? "" + r + "%" + n : n;
  }
  function s(e, t, r) {
    return i(e, t === a.PrefetchKind.FULL, r);
  }
  function l(e) {
    let { url: t, nextUrl: r, tree: n, prefetchCache: o, kind: s, allowAliasing: l = !0 } = e,
      u = (function (e, t, r, n, o) {
        for (let s of (void 0 === t && (t = a.PrefetchKind.TEMPORARY), [r, null])) {
          let r = i(e, !0, s),
            l = i(e, !1, s),
            u = e.search ? r : l,
            c = n.get(u);
          if (c && o) {
            if (c.url.pathname === e.pathname && c.url.search !== e.search)
              return { ...c, aliased: !0 };
            return c;
          }
          let f = n.get(l);
          if (o && e.search && t !== a.PrefetchKind.FULL && f && !f.key.includes("%"))
            return { ...f, aliased: !0 };
        }
        if (t !== a.PrefetchKind.FULL && o) {
          for (let t of n.values())
            if (t.url.pathname === e.pathname && !t.key.includes("%")) return { ...t, aliased: !0 };
        }
      })(t, s, r, o, l);
    return u
      ? ((u.status = h(u)),
        u.kind !== a.PrefetchKind.FULL &&
          s === a.PrefetchKind.FULL &&
          u.data.then((e) => {
            if (
              !(
                Array.isArray(e.flightData) &&
                e.flightData.some((e) => e.isRootRender && null !== e.seedData)
              )
            )
              return c({
                tree: n,
                url: t,
                nextUrl: r,
                prefetchCache: o,
                kind: null != s ? s : a.PrefetchKind.TEMPORARY,
              });
          }),
        s && u.kind === a.PrefetchKind.TEMPORARY && (u.kind = s),
        u)
      : c({ tree: n, url: t, nextUrl: r, prefetchCache: o, kind: s || a.PrefetchKind.TEMPORARY });
  }
  function u(e) {
    let { nextUrl: t, tree: r, prefetchCache: n, url: o, data: i, kind: l } = e,
      u = i.couldBeIntercepted ? s(o, l, t) : s(o, l),
      c = {
        treeAtTimeOfPrefetch: r,
        data: Promise.resolve(i),
        kind: l,
        prefetchTime: Date.now(),
        lastUsedTime: Date.now(),
        staleTime: i.staleTime,
        key: u,
        status: a.PrefetchCacheEntryStatus.fresh,
        url: o,
      };
    return (n.set(u, c), c);
  }
  function c(e) {
    let { url: t, kind: r, tree: i, nextUrl: l, prefetchCache: u } = e,
      c = s(t, r),
      f = o.prefetchQueue.enqueue(() =>
        (0, n.fetchServerResponse)(t, { flightRouterState: i, nextUrl: l, prefetchKind: r }).then(
          (e) => {
            let r;
            if (
              (e.couldBeIntercepted &&
                (r = (function (e) {
                  let { url: t, nextUrl: r, prefetchCache: n, existingCacheKey: a } = e,
                    o = n.get(a);
                  if (!o) return;
                  let i = s(t, o.kind, r);
                  return (n.set(i, { ...o, key: i }), n.delete(a), i);
                })({ url: t, existingCacheKey: c, nextUrl: l, prefetchCache: u })),
              e.prerendered)
            ) {
              let t = u.get(null != r ? r : c);
              t &&
                ((t.kind = a.PrefetchKind.FULL), -1 !== e.staleTime && (t.staleTime = e.staleTime));
            }
            return e;
          },
        ),
      ),
      d = {
        treeAtTimeOfPrefetch: i,
        data: f,
        kind: r,
        prefetchTime: Date.now(),
        lastUsedTime: null,
        staleTime: -1,
        key: c,
        status: a.PrefetchCacheEntryStatus.fresh,
        url: t,
      };
    return (u.set(c, d), d);
  }
  function f(e) {
    for (let [t, r] of e) h(r) === a.PrefetchCacheEntryStatus.expired && e.delete(t);
  }
  let d = 1e3 * Number("0"),
    p = 1e3 * Number("300");
  function h(e) {
    let { kind: t, prefetchTime: r, lastUsedTime: n } = e;
    return Date.now() < (null != n ? n : r) + d
      ? n
        ? a.PrefetchCacheEntryStatus.reusable
        : a.PrefetchCacheEntryStatus.fresh
      : t === a.PrefetchKind.AUTO && Date.now() < r + p
        ? a.PrefetchCacheEntryStatus.stale
        : t === a.PrefetchKind.FULL && Date.now() < r + p
          ? a.PrefetchCacheEntryStatus.reusable
          : a.PrefetchCacheEntryStatus.expired;
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
